const contact = {
  actions: {
    async submitContactForm(context, body) {
      return await context.dispatch("postRequest", {
        api: "ext_web/quote/submit/contact_form/submitter",
        body,
      });
    },
    async getReasons(context) {
      return await context.dispatch("getRequest", {
        api: "ext_web/web/reason",
      });
    },
    async submitQuoteRequest(context, { body }) {
      return await context.dispatch("postRequest", {
        api: "ext_web/quote/submit/intake_quote/submitter",
        body,
      });
    },
    async getIntakeLists(context) {
      return await context.dispatch("getRequest", {
        api: "ext_web/web/list/intake",
      });
    },
  },
};

export default contact;
